import { initializers } from './includes.js';
import Backbone from 'backbone';
import $ from 'jquery';
Backbone.$ = $;
import Marionette from 'backbone.marionette';
import moment from 'moment';

//import { support } from './support/initializer';

window.moment = moment;

if (!window._appStarted) {
  window._appStarted = false;
}

if (!window.sfm) {
  window.sfm = {
    appMeta: {
      initializer: null
    }
  };
}

const init = window.sfm.appMeta.initializer;

const app = new Marionette.Application({
  started() {
    return window._appStarted;
  },

  onStart(options) {
    if (init) {
      const init = initializers[options.initializer];
      init.apply(this, [options]);
    }

//    if (options.userIsStaff) {
//      support.apply(this, [options]);
//    }

    Backbone.history.start();
    window._appStarted = true;
  }
});

function csrfSafeMethod(method) {
  return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
}

/**
 * Return a cookie. This comes directly from Django's documentation.
 * @param {string} name The cookie name.
 * @returns {string} The cookie value.
 */
function getCookie(name) {
  let cookieValue = null;

  if (document.cookie && document.cookie != '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = window.jQuery.trim(cookies[i]);
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) == `${name}=`) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

/** Use proper URIEncoding */
$.ajaxSettings.traditional = true;

const csrftoken = getCookie('csrftoken');

$.ajaxSetup({
  beforeSend(xhr, settings) {
    if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
      xhr.setRequestHeader('X-CSRFToken', csrftoken);
    }
  }
});

window.sfm.app = app;

if (!app.started()) {
  app.start(window.sfm.appMeta);
}

module.exports = app;
require('./names/widget');



// WEBPACK FOOTER //
// ./driver.js